
export { HorizontalProductCardSkeleton } from "/codebuild/output/src3644705884/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src3644705884/src/packages/shared-components/src/components/ProductCard/index.ts"